import React from "react";

import type { Event } from "~/calendar/CalendarPage";

import { getNumOccurrencesFromRRule } from "../utils/meetingGuidelinesUtils";
import MeetingCost from "./MeetingCost";
import { useCalculateMeetingCost } from "./MeetingCostEditPanel";

import type { ViewEventDetailQuery } from "~/__generated__/ViewEventDetailQuery.graphql";

import styles from "../ViewEvent/ViewEvent.module.css";

interface MeetingCostViewPanelProps {
	attendees: NonNullable<ViewEventDetailQuery["response"]["event"]>["attendees"];
	event: Event;
	recurrenceRule: NonNullable<ViewEventDetailQuery["response"]["event"]>["recurrenceRule"];
}

export default function MeetingCostViewPanel({ attendees, event, recurrenceRule }: MeetingCostViewPanelProps) {
	const filteredAttendees = attendees.filter(attendee => attendee?.responseStatus !== "declined");

	const meetingLengthInMinutes = (event.end.getTime() - event.start.getTime()) / 1000 / 60;

	const rRule = recurrenceRule?.find(r => r?.includes("RRULE"));

	const { numOccurrences, isInfinite } = getNumOccurrencesFromRRule(rRule, event.start);

	const { meetingCostOccurrence, meetingCostSeries, isMonetary } = useCalculateMeetingCost(
		filteredAttendees.map(attendee => ({
			id: attendee?.user?.id,
		})),
		meetingLengthInMinutes,
		numOccurrences,
		true, // We don't want to duplicate the viewer in the calculation as they will already be included in the attendees if they are in the event
	);

	if (event?.isAllDay || filteredAttendees.length <= 1) return null;

	return (
		<MeetingCost
			wrapperStyles={styles}
			meetingCostOccurrence={meetingCostOccurrence}
			meetingCostSeries={meetingCostSeries}
			numOccurrences={numOccurrences}
			isMonetary={isMonetary}
			isInfinite={isInfinite}
		/>
	);
}
